var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWallet2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0C1.00898 0 0 1.03486 0 2.30769V12.6923C0 13.9651 1.00898 15 2.25 15H15.75C16.991 15 18 13.9651 18 12.6923V5.76923C18 4.49639 16.991 3.46154 15.75 3.46154H2.53125C2.06367 3.46154 1.6875 3.07572 1.6875 2.59615C1.6875 2.11659 2.06367 1.73077 2.53125 1.73077H16.0312C16.4988 1.73077 16.875 1.34495 16.875 0.865385C16.875 0.385817 16.4988 0 16.0312 0H2.25ZM14.625 8.07692C14.9234 8.07692 15.2095 8.19849 15.4205 8.41488C15.6315 8.63126 15.75 8.92475 15.75 9.23077C15.75 9.53679 15.6315 9.83027 15.4205 10.0467C15.2095 10.263 14.9234 10.3846 14.625 10.3846C14.3266 10.3846 14.0405 10.263 13.8295 10.0467C13.6185 9.83027 13.5 9.53679 13.5 9.23077C13.5 8.92475 13.6185 8.63126 13.8295 8.41488C14.0405 8.19849 14.3266 8.07692 14.625 8.07692Z",
    fill: "#D0DAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet2);
export default __webpack_public_path__ + "static/media/icon-wallet-2.4a68f1febaf88e1883bac3d8e7a1dce1.svg";
export { ForwardRef as ReactComponent };